import { render, staticRenderFns } from "./Headers.vue?vue&type=template&id=4f042d95&"
import script from "./Headers.vue?vue&type=script&lang=js&"
export * from "./Headers.vue?vue&type=script&lang=js&"
import style0 from "./Headers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports